import type { ComponentType } from 'react'
import { GccApp } from '@tn/ui/gcc'

export const variantApps: Record<string, ComponentType> = {
  '/gcc': GccApp,
}
